import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kxy3xgbs2: FaireProductEntity = {
  token: "p_4kxy3xgbs2",
  type: "product",
  name: "Vivani Dubai Style Chocolate 35g (Türkiye)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/35aaafb85a3ec0f213044a5fcf8f27b3c7713402390494687f5935d6118507a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00d8c6123a3916f0d7d6d65becd87ec529ae68193c1d59f61a4219004ea58bd3.jpeg",
  ],
  priceDollars: 2.15,
  description:
    "Vivani Dubai Style Chocolate – Luxurious, Exotic & Rich 🍫✨🌴\n\nExperience a taste of luxury with Vivani Dubai Style Chocolate. This 35g premium chocolate bar is crafted to evoke the richness, elegance, and exotic flavor traditions associated with Dubai-style confectionery. Smooth, velvety, and indulgently sweet, it’s perfect for chocolate lovers who enjoy upscale, uniquely inspired treats.\n\nWhether you're adding it to a gourmet gift set, enjoying a moment of indulgence, or exploring international chocolate varieties, this bar delivers a refined and satisfying chocolate experience.\n\n✅ Premium chocolate inspired by Dubai’s luxurious flavor traditions\n✅ Smooth, rich texture with high-quality ingredients\n✅ 35g size—perfect for a quick gourmet treat\n✅ Ideal for gifting, travel snacks, or chocolate collectors\n✅ Great for those who enjoy international and specialty chocolates\n\nSize: 35g\nAllergens: Contains milk and soy; may contain traces of nuts or gluten (check packaging).\n\n✨ Elegant, rich, and crafted for indulgence—Vivani Dubai Style Chocolate brings a touch of luxury to every bite.\n",
  tags: [],
  msrpDollars: 4.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:35.577Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
